import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=ef169b58&"
import script from "./order_list.vue?vue&type=script&lang=js&"
export * from "./order_list.vue?vue&type=script&lang=js&"
import style0 from "./order_list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports